import { get, post, deleteFun, put } from '@/utils/request.js';

// 菜单管理

/**
 * 菜单列表
 */
export function getMenuList(params) {
    return get('/mpp/menu/findAllAsTree', params);
}

/**
 * 菜单详情
 * id
 */
export function getMenuById(params) {
    return get('/mpp/menu/get', params);
}

/**
 * 添加菜单
 * id
 */
export function addMenu(params) {
    return post('/mpp/menu/add', params);
}

/**
 * 修改菜单
 * id
 */
export function editMenu(params) {
    return post('/mpp/menu/edit', params);
}

/**
 * 删除菜单
 * menuIds 支持批量删除
 */
export function deleteMenu(params) {
    return deleteFun('/mpp/menu/delete', params);
}
